// assets/pincode-router.js
(function () {

  /* ================= CONFIG ================= */

  const CSV_URL =
    "https://cdn.shopify.com/s/files/1/0717/4137/4696/files/pincode_storefront_mapping_with_Egham_Eastcote_2mile.csv?v=1789043913";

  const STORES = [
    { key: "Reading",    domain: "https://reading.7thheavenbakery.co.uk/",      lat: 51.4426,  lng: -0.9450 },
    { key: "Wandsworth", domain: "https://7thheavenbakery.co.uk/",              lat: 51.4513,  lng: -0.1921 },
    { key: "Horsham",    domain: "https://horsham.7thheavenbakery.co.uk/",      lat: 51.0627,  lng: -0.3274 },
    { key: "Ashford",    domain: "https://ashford.7thheavenbakery.co.uk/",      lat: 51.1480,  lng: 0.8670  },
    { key: "Rugby",      domain: "https://rugby.7thheavenbakery.co.uk/",        lat: 52.37092, lng: -1.26417 },
    { key: "Aberdeen",   domain: "https://aberdeen.7thheavenbakery.co.uk/",     lat: 57.1497,  lng: -2.0943 },
    { key: "Cotteridge", domain: "https://cotteridge.7thheavenbakery.co.uk/",   lat: 52.4265,  lng: -1.9646 },
    { key: "Whitton",    domain: "https://whitton.7thheavenbakery.co.uk/",      lat: 51.447,   lng: -0.357  },
    { key: "Walthamstow", domain: "https://walthamstow.7thheavenbakery.co.uk/", lat: 51.584, lng: -0.020 },
    { key: "Stanmore", domain: "https://stanmore.7thheavenbakery.co.uk/", lat: 51.618, lng: -0.316 },
    { key: "Sale", domain: "https://sale.7thheavenbakery.co.uk/", lat: 53.4248, lng: -2.3220 },
    { key: "High Wycombe", domain: "https://highwycombe.7thheavenbakery.co.uk/", lat: 51.4910, lng: -0.5070 },
    { key: "Hale", domain: "https://hale.7thheavenbakery.co.uk/", lat: 53.5425, lng: -2.7146 },
    { key: "Hull", domain: "https://hull.7thheavenbakery.co.uk/", lat: 53.7443, lng: -0.3042 },
    { key: "potterbars", domain: "https://pottersbar.7thheavenbakery.co.uk/", lat: 51.6972, lng: -0.1750 },
    { key: "Richmond", domain: "https://richmond.7thheavenbakery.co.uk/", lat: 51.4641651, lng: -0.268489 },
    { key: "Egham", domain: "https://egham.7thheavenbakery.co.uk/", lat: 51.4327456, lng: -0.5447682 },
    { key: "Pinner", domain: "https://pinner.7thheavenbakery.co.uk/", lat: 51.578338, lng: -0.3988766 }
  ];

  /* ============== HELPERS ============== */

  function normalizePostcode(pc) {
    return pc.toUpperCase().replace(/\s+/g, "");
  }

  function extractPrefix(pc) {
    const clean = normalizePostcode(pc);
    const match = clean.match(/^([A-Z]{1,2}\d{1,2})/);
    return match ? match[1] : null;
  }

  /* ============== CSV HANDLING ============== */

  async function fetchCsv(url) {
    const res = await fetch(url);
    if (!res.ok) throw new Error("Unable to fetch CSV");

    const text = await res.text();
    const lines = text.split(/\r?\n/).filter(Boolean);

    const rows = [];
    let start = 0;

    if (lines[0].toLowerCase().includes("post")) start = 1;

    for (let i = start; i < lines.length; i++) {
      const cols = lines[i].split(",").map(c => c.trim());

      rows.push({
        postcode: normalizePostcode(cols[0] || ""),
        outlet: (cols[1] || "").trim()
      });
    }

    return rows;
  }

  /* ========== PREFIX MAP ========== */

  function buildPrefixMap(rows) {
    const map = {};

    rows.forEach(r => {
      const prefix = extractPrefix(r.postcode);
      if (prefix && r.outlet && !map[prefix]) {
        map[prefix] = r.outlet;
      }
    });

    return map;
  }

  function findOutletByPostcode(input, map) {
    const prefix = extractPrefix(input);
    if (!prefix) return null;

    return map[prefix] || null;
  }

  /* ============== UTILITIES ============== */

  function gotoDomain(domain) {
    if (!domain) return;
    const params = window.location.search || "";
    window.location.href = domain + params;
  }

  function distanceKm(lat1, lon1, lat2, lon2) {
    const R = 6371;

    const dLat = (lat2 - lat1) * Math.PI / 180;
    const dLon = (lon2 - lon1) * Math.PI / 180;

    const a =
      Math.sin(dLat / 2) ** 2 +
      Math.cos(lat1 * Math.PI / 180) *
      Math.cos(lat2 * Math.PI / 180) *
      Math.sin(dLon / 2) ** 2;

    return R * (2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a)));
  }

  /* ============== MAIN LOGIC ============== */

  async function initRouter() {
    const root = document.getElementById("pincode-router-root");
    if (!root) return;

    const selectedKey = localStorage.getItem("selected_store_key");
    const selectedDomain = localStorage.getItem("selected_store_domain");
    const currentOrigin = window.location.origin.replace(/\/$/, "");

    // ✅ Skip popup if already on correct store
    if (
      selectedKey &&
      selectedDomain &&
      currentOrigin === selectedDomain.replace(/\/$/, "")
    ) {
      root.style.display = "none";
      return;
    }

    root.style.display = "block";

    let rows = [];
    try {
      rows = await fetchCsv(CSV_URL);
    } catch (e) {
      console.warn("CSV load failed", e);
    }

    const prefixMap = buildPrefixMap(rows);

    const btnCheck = document.getElementById("pr-check");
    const btnUse = document.getElementById("pr-use-location");
    const btnClose = document.getElementById("pr-close");
    const input = document.getElementById("pr-postcode");
    const errEl = document.getElementById("pr-error");

    btnClose.onclick = () => (root.style.display = "none");

    btnCheck.onclick = () => {
      errEl.style.display = "none";

      const val = input.value.trim();

      if (!val) {
        errEl.innerText = "Please enter a postcode.";
        errEl.style.display = "block";
        return;
      }

      const outlet = findOutletByPostcode(val, prefixMap);

      if (!outlet) {
        errEl.innerText = "No outlet found for this postcode.";
        errEl.style.display = "block";
        return;
      }

      const store = STORES.find(
        s => s.key.toLowerCase() === outlet.toLowerCase()
      );

      if (!store) {
        errEl.innerText = "Outlet found but domain not configured.";
        errEl.style.display = "block";
        return;
      }

      // ✅ Save selection
      localStorage.setItem("selected_store_key", store.key);
      localStorage.setItem("selected_store_domain", store.domain);

      gotoDomain(store.domain);
    };

    btnUse.onclick = () => {
      if (!navigator.geolocation) {
        errEl.innerText = "Geolocation not supported.";
        errEl.style.display = "block";
        return;
      }

      navigator.geolocation.getCurrentPosition(
        pos => {
          let nearest = null;

          STORES.forEach(s => {
            const d = distanceKm(
              pos.coords.latitude,
              pos.coords.longitude,
              s.lat,
              s.lng
            );

            if (!nearest || d < nearest.dist) {
              nearest = { store: s, dist: d };
            }
          });

          if (nearest) {
            localStorage.setItem("selected_store_key", nearest.store.key);
            localStorage.setItem("selected_store_domain", nearest.store.domain);
            gotoDomain(nearest.store.domain);
          }
        },
        () => {
          errEl.innerText = "Unable to detect location.";
          errEl.style.display = "block";
        }
      );
    };
  }

  if (document.readyState !== "loading") {
    setTimeout(initRouter, 200);
  } else {
    document.addEventListener("DOMContentLoaded", initRouter);
  }

})();